import * as React from "react";
import "./styles/peremen.scss";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import "./styles/styles.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./pages/template/Layout";
import Home from "./pages/home/home";
import Awards from "./pages/awards/awards";
import Portfolio from "./pages/portfolio/portfolio";
import Publication from "./pages/publication/publication";
import Feedback from "./pages/feedback/feedback";
import Contacts from "./pages/contacts/contacts";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="portfolio" element={<Portfolio />} />
       
          <Route path="awards" element={<Awards />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="contacts" element={<Contacts />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
